import { isIterable } from "@thi.ng/checks";
import { iterator1 } from "../iterator";
import { throttle } from "./throttle";
export function takeNth(n, src) {
    if (isIterable(src)) {
        return iterator1(takeNth(n), src);
    }
    n = Math.max(0, n - 1);
    return throttle(() => {
        let skip = 0;
        return () => (skip === 0 ? ((skip = n), true) : (skip--, false));
    });
}
